import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=166018fc&lang=scss&scoped=true"
import "./index.vue?vue&type=style&index=1&id=166018fc&lang=scss"

import exportComponent from "/Users/lisha/Desktop/project/jierong/weidiansi-mobilemall3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166018fc"]])

export default __exports__